import Model from "./Model";
import CorrectionScoreModel from "./CorrectionScoreModel";
import AnnotationModel from './AnnotationModel';
import EssayReplyModel from './EssayReplyModel';
import _ from "lodash";

export default class CorrectionModel extends Model {
  id: number;
  score: number;
  comment: string;
  essayReplyId: number;
  finalizedAt: Date;

  constructor(correction: any, getters: any) {
    super(getters);
    this.id = correction.id;
    this.score = correction.score;
    this.comment = correction.comment;
    this.finalizedAt = new Date(correction.finalizedAt);
    this.essayReplyId = correction.essayReplyByEssayReplyId || correction.essayReplyId;
  }
  maxScore(): number {
    return this.essay().subject().examMode().maxScore;
  }
  essay(): EssayReplyModel {
    return this.getters.essayReplyById(this.essayReplyId);
  }
  link(): string {
    return this.essay().link();
  }
  correctionScores(): CorrectionScoreModel[] {
    return this.getters.correctionScoresByCorrectionId(this.id);
  }
  annotations(): AnnotationModel[] {
    return _.flatten(
      this.correctionScores().map((correctionScore: CorrectionScoreModel) =>
         correctionScore.annotations()
      )
    ).sort(
        (a:AnnotationModel, b:AnnotationModel) => {
          let aCoordinate = a.coordinates;
          let bCoordinate = b.coordinates;
          if (aCoordinate.top < bCoordinate.top) {
            return -1
          } else if (aCoordinate.top === bCoordinate.top) {
            return aCoordinate.left - bCoordinate.left
          } else {
            return 1
          }
        }
      )
  }
}